"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFilterContainer = exports.default = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const attributes_filter_component_1 = require("./attributes-filter.component");
const attributes_utils_1 = require("./attributes.utils");
const formal_attributes_1 = require("../../formal-attributes");
const State = __importStar(require("../../../store"));
const store_1 = require("../../../store");
const AttributesFilterContainer = ({ openAttributes, setOpenAttributes, searchTerm, className, attributeTotals, isProductCountsLoading, }) => {
    const includedAttributesIds = (0, store_1.useProductsIncludedAttributesIds)();
    const excludedAttributesIds = (0, store_1.useProductsExcludedAttributesIds)();
    const { actualAttributes } = (0, store_1.useRefinementsDataSelector)();
    const refinementsLoading = (0, store_1.useRefinementsLoadingSelector)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const normalizeTermForSearch = (s) => s.trim().toLowerCase();
    const normalizedSearchTerm = normalizeTermForSearch(searchTerm);
    const { loadFormalAttributes, getAttributeName, getAttributeValueName } = (0, formal_attributes_1.useFormalAttributes)();
    const isAttributesLoading = refinementsLoading || isProductCountsLoading;
    const actualAttributesMap = actualAttributes.reduce((map, actualAttribute) => {
        let entry = map.get(actualAttribute.attributeId);
        if (!entry) {
            map.set(actualAttribute.attributeId, entry = [actualAttribute]);
        }
        else {
            entry.push(actualAttribute);
        }
        return map;
    }, new Map());
    (0, react_1.useEffect)(() => {
        if (actualAttributes === null || actualAttributes === void 0 ? void 0 : actualAttributes.length) {
            void loadFormalAttributes(actualAttributes);
        }
    }, [actualAttributes, loadFormalAttributes]);
    const refinementsFilter = (0, store_1.useRefinementsFilterSelector)();
    const filteredExpansionAttributes = (0, react_1.useMemo)(() => [...actualAttributesMap.entries()]
        .map(([attributeId, subAttributes]) => {
        const subAttributesWithTitle = subAttributes.map((subAttribute) => {
            var _a, _b;
            // Because "sub attributes" are actually just the same attribute with different valueIds,
            // For now inclusion/exclusion and counts are always going to be the same for all subAttributes.
            const subAttributeId = subAttribute.attributeId;
            const isMatchesFilter = refinementsFilter === State.AvailableRefinementType.Matches;
            const isInIncludedAttributesIds = includedAttributesIds.includes(subAttributeId);
            const isInExcludedAttributesIds = excludedAttributesIds.includes(subAttributeId);
            const isMatch = isInIncludedAttributesIds || isInExcludedAttributesIds;
            const isShown = isMatchesFilter ? isMatch : true;
            const title = (0, attributes_utils_1.getAttributeValueTitle)({ subAttribute, getAttributeName, getAttributeValueName });
            return isShown && title ? Object.assign(Object.assign({}, subAttribute), { id: [subAttributeId, (_a = subAttribute.valueId) !== null && _a !== void 0 ? _a : '', (_b = subAttribute.valueName) !== null && _b !== void 0 ? _b : ''].join(store_1.ATTRIBUTE_PROPERTY_DELIMITER), title, total: attributeTotals[subAttribute.attributeId] }) : null;
        })
            .filter((subAttributeWithTitle) => !!subAttributeWithTitle)
            .sort((a, b) => (a.title > b.title ? 1 : -1));
        const title = (0, attributes_utils_1.getAttributeValueTitle)({ subAttribute: { attributeId }, getAttributeName, getAttributeValueName });
        return title ? {
            id: attributeId,
            attributeId,
            title,
            total: attributeTotals[attributeId],
            subAttributes: subAttributesWithTitle,
        } : null;
    })
        .filter((attribute) => !!attribute)
        .map((_a) => {
        var { title, subAttributes } = _a, rest = __rest(_a, ["title", "subAttributes"]);
        return (Object.assign({ title, subAttributes: normalizeTermForSearch(title).includes(normalizedSearchTerm)
                ? subAttributes : subAttributes.filter(({ title }) => normalizeTermForSearch(title).includes(normalizedSearchTerm)) }, rest));
    })
        .filter(({ subAttributes }) => !(0, ramda_1.isEmpty)(subAttributes)), [
        normalizedSearchTerm,
        excludedAttributesIds,
        includedAttributesIds,
        refinementsFilter,
        attributeTotals,
        getAttributeName,
        getAttributeValueName,
        actualAttributesMap,
    ]);
    const handleHeaderClick = (0, react_1.useCallback)((id) => setOpenAttributes((0, ramda_1.assoc)(id, !openAttributes[id], openAttributes)), [openAttributes, setOpenAttributes]);
    const handleExpandAll = (0, react_1.useCallback)(() => setOpenAttributes(actualAttributes.reduce((acc, attribute) => (Object.assign(Object.assign({}, acc), { [attribute.attributeId]: true })), {})), [actualAttributes]);
    const handleCollapseAll = (0, react_1.useCallback)(() => setOpenAttributes({}), [setOpenAttributes]);
    (0, react_1.useEffect)(() => {
        if (actualAttributesMap === null || actualAttributesMap === void 0 ? void 0 : actualAttributesMap.size) {
            dispatch((0, store_1.attributesSetValuesMap)(actualAttributesMap));
        }
    }, [actualAttributesMap]);
    return (react_1.default.createElement(attributes_filter_component_1.AttributesFilter, { className: className, expansionAttributes: filteredExpansionAttributes, onCollapseAll: handleCollapseAll, onExpandAll: handleExpandAll, onHeaderClick: handleHeaderClick, openAttributes: openAttributes, isAttributesLoading: isAttributesLoading }));
};
const MemoizedAttributesFilterContainer = react_1.default.memo(AttributesFilterContainer);
exports.default = MemoizedAttributesFilterContainer;
exports.AttributesFilterContainer = MemoizedAttributesFilterContainer;
